import { Extension } from '@tiptap/core'
import { EditorState, Plugin, PluginKey, Transaction } from '@tiptap/pm/state'

export function exitCodeBlockAfterDeletingLastCharacter(
    transactions: readonly Transaction[],
    oldState: EditorState,
    newState: EditorState,
): Transaction | null {
    if (!transactions.some(transaction => transaction.docChanged)) return null

    const oldSelection = oldState.selection
    const newSelection = newState.selection
    const oldParent = oldSelection.$from.parent
    const newParent = newSelection.$from.parent

    // Code-block shortcuts also create an empty node. Only exit when a block that
    // previously contained text became empty through this document change.
    if (
        !newSelection.empty ||
        oldParent.type.name !== 'codeBlock' ||
        newParent.type.name !== 'codeBlock' ||
        oldParent.content.size === 0 ||
        newParent.content.size !== 0
    ) {
        return null
    }

    const paragraphType = newState.schema.nodes.paragraph
    if (!paragraphType) return null

    return newState.tr.setNodeMarkup(newSelection.$from.before(), paragraphType)
}

export const CodeBlockExitPlugin = Extension.create({
    name: 'codeBlockExit',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('codeBlockExit'),
                appendTransaction: exitCodeBlockAfterDeletingLastCharacter,
            }),
        ]
    },
})

export default CodeBlockExitPlugin
